export const callbackErrorMessages = new Map<string, string>([
	['authentication_failed', 'Authentication failed. Please try again.'],
	['alias_mismatch', "The account you signed in with doesn't match the address you entered."],
	['no_user', "We couldn't find an active user for that address."],
	['ambiguous_user', 'That address belongs to more than one active user. Contact support.'],
	['provider_not_enabled', "This account doesn't allow signing in with that provider."],
	['alias_unsupported_client', "Signing in with that address isn't supported here yet."],
]);

// Refusals about the address that was typed, so they read best next to it on the login page.
const addressRefusals = new Set(['alias_mismatch', 'no_user', 'ambiguous_user', 'provider_not_enabled']);

export const getCallbackErrorMessage = (code: string) =>
	callbackErrorMessages.get(code) ?? 'An error occurred during authentication.';

export const isAddressRefusal = (code: string | undefined) => !!code && addressRefusals.has(code);
